/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VinScrapingFailureLogsWithParams_list = {
    readonly vinScrapeLogs: ReadonlyArray<{
        readonly shipmentSlug: string;
        readonly vin: string;
        readonly retryCount: number;
        readonly hyperlink: string;
    }> | null;
    readonly paginationMeta: {
        readonly totalPages: number;
    } | null;
    readonly " $refType": "VinScrapingFailureLogsWithParams_list";
};
export type VinScrapingFailureLogsWithParams_list$data = VinScrapingFailureLogsWithParams_list;
export type VinScrapingFailureLogsWithParams_list$key = {
    readonly " $data"?: VinScrapingFailureLogsWithParams_list$data;
    readonly " $fragmentRefs": FragmentRefs<"VinScrapingFailureLogsWithParams_list">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VinScrapingFailureLogsWithParams_list",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VinScrapeFailureLog",
      "kind": "LinkedField",
      "name": "vinScrapeLogs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shipmentSlug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "retryCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hyperlink",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Paginate",
      "kind": "LinkedField",
      "name": "paginationMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalPages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VinScrapeFailureLogs",
  "abstractKey": null
};
(node as any).hash = '8dc5cc846dddb5701958640220b829e0';
export default node;
